import React from "react";
import { config } from "../../../../../config";

const UpdateFreeThing = ({ formData, setFormData, handleChange, handleSubmit, loading, onCancel, error }) => {
  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Free Thing</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., free-ebook"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Free Ebook"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Subtitle</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Get your free copy today"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border w-full p-2"
            rows="4"
            placeholder="Enter detailed description..."
            required
          ></textarea>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Download Link</label>
          <input
            type="url"
            name="download_link"
            value={formData.download_link}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., https://example.com/download"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Icon</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., fas fa-book or image URL"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Button Text</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Download Now"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Button Icon</label>
          <input
            type="text"
            name="button_icon"
            value={formData.button_icon}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., fas fa-download"
          />
        </div>

        <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Free Thing"}
            </button>
        </div>

       
      </form>
    </div>
  );
};

export default UpdateFreeThing;